import { FaGlobe, FaCogs, FaUserTie, FaLaptopCode, FaIndustry } from "react-icons/fa";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import "swiper/css/effect-coverflow"; // Import coverflow effect styles
import { Pagination, Autoplay, EffectCoverflow } from "swiper/modules";
import AnimatedHeading from "../shared/AnimatedHeading";

const WhyChooseUsSection = () => {
  const features = [
    {
      icon: <FaGlobe className="text-purple-300 w-12 h-12" />,
      title: "Global Expertise",
      description: "Operating in Sri Lanka and the UK with international clients.",
      image: "/images/home/global-expertise.jpg", // Background image for this slide
    },
    {
      icon: <FaCogs className="text-purple-300 w-12 h-12" />,
      title: "End-to-End Solutions",
      description: "From planning to implementation and support.",
      image: "/images/home/end-to-end-solutions.jpg", // Background image for this slide
    },
    {
      icon: <FaIndustry className="text-purple-300 w-12 h-12" />,
      title: "Industry Experience",
      description: "Serving businesses across diverse sectors.",
      image: "/images/home/industry-experience.jpg", // Background image for this slide
    },
    {
      icon: <FaUserTie className="text-purple-300 w-12 h-12" />,
      title: "Client-Centric Approach",
      description: "Solutions customized to your specific requirements.",
      image: "/images/home/client-centric.jpg", // Background image for this slide
    },
    {
      icon: <FaLaptopCode className="text-purple-300 w-12 h-12" />,
      title: "Cutting-Edge Technology",
      description: "Leveraging the latest advancements in IT.",
      image: "/images/home/cutting-edge-tech.jpg", // Background image for this slide
    },
  ];

  return (
    <section className="py-16 bg-gradient-to-br from-gray-200 via-violet-200 to-gray-200 text-gray-800">
      <div className="container mx-auto px-6 max-w-6xl">
        {/* About Us Section */}
        <div className="mb-10 text-center max-w-6xl">
          <h5 className="text-md font-bold text-center mb-2 text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-purple-500">
            About Us
          </h5>
          <h2 className="text-3xl sm:text-4xl font-extrabold mb-3 pb-3 text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600">
            Your Technology Partner for Business Growth
          </h2>
          <p className="text-gray-700 text-md">
            Hither Tech provides premium digital and IT services to businesses looking to leverage technology for competitive advantage. Our team of specialists combines technical expertise with business acumen to deliver solutions that drive efficiency, innovation, and growth.
          </p>
        </div>
        <AnimatedHeading
          text="Why choose Hither Tech"
          className="mb-8 text-center text-gray-900"
        />
        <Swiper
          modules={[Pagination, Autoplay, EffectCoverflow]} // Add EffectCoverflow module
          effect="coverflow" // Enable 3D coverflow effect
          grabCursor={true}
          centeredSlides={true}
          slidesPerView={1}
          loop={true}
          coverflowEffect={{
            rotate: 50, // Rotation angle
            stretch: 0, // Stretch space between slides
            depth: 100, // Depth of the 3D effect
            modifier: 1, // Effect intensity
            slideShadows: true, // Enable shadows
          }}
          pagination={{ clickable: true }}
          autoplay={{
            delay: 3000, // Auto-scroll every 3 seconds
            disableOnInteraction: false,
          }}
          breakpoints={{
            640: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
          style={{ height: "300px" }}
        >
          {features.map((feature, index) => (
            <SwiperSlide key={index}>
              <div
                className="relative flex flex-col items-center text-center bg-cover bg-center p-8 rounded-lg shadow-lg hover:shadow-2xl transition-shadow duration-300 h-full"
                style={{
                  backgroundImage: `url(${feature.image})`,
                  filter: "brightness(0.9)", // Darken the background image
                }}
              >
                {/* Overlay */}
                <div className="absolute inset-0 bg-black/50 rounded-lg"></div>
                {/* Content */}
                <div className="relative z-10">
                  <div className="mb-4">{feature.icon}</div>
                  <h3 className="text-xl font-semibold mb-2 text-white">
                    {feature.title}
                  </h3>
                  <p className="text-gray-200">{feature.description}</p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default WhyChooseUsSection;